module.exports = __webpack_public_path__ + "static/media/grados_posgrados.af83e00e.png";